import { useState } from 'react';

import { useSetCompanyNameMutation } from '@app/api/Client/api';
import { SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

import type { BaseState } from './useBaseState';

type useOrganizationCommentParams = Pick<
  BaseState,
  | 'leadCardData'
  | 'setOrganizationComment'
  | 'organizationComment'
  | 'refreshLatestHistory'
>;

export const useOrganizationComment = ({
  leadCardData,
  setOrganizationComment,
  organizationComment,
  refreshLatestHistory,
}: useOrganizationCommentParams) => {
  const [isOrganizationCommentModalOpen, setIsOrganizationCommentModalOpen] =
    useState(false);

  const clientId = leadCardData?.ClientId ?? leadCardData?.ClientView.Id;

  const { showNotification } = useNotification();
  const { activeBranchId } = useUserPrint();

  const [setCompanyName, { isLoading: isOrganizationCommentLoading }] =
    useSetCompanyNameMutation();

  const handleCloseOrganizationCommentModal = () => {
    setIsOrganizationCommentModalOpen(false);
  };

  const handleSaveOrganizationComment = async (
    value: string
  ): Promise<boolean> => {
    try {
      if (!clientId) {
        showNotification('Ошибка: clientId не найден');
        return false;
      }

      await setCompanyName({
        clientId,
        companyName: value,
        ActiveBranchId: activeBranchId,
      }).unwrap();

      setOrganizationComment(value);
      handleCloseOrganizationCommentModal();
      showNotification('Комментарий к организации успешно сохранён', SUCCESS);
      void refreshLatestHistory();
      return true;
    } catch (error) {
      showNotification(handleCatchError(error));
      return false;
    }
  };

  const handleOrganizationCommentClick = () => {
    setIsOrganizationCommentModalOpen(true);
  };

  return {
    isOrganizationCommentModalOpen,
    setIsOrganizationCommentModalOpen,
    handleOrganizationCommentClick,
    isOrganizationCommentLoading,
    handleSaveOrganizationComment,
    setOrganizationComment,
    organizationComment,
    handleCloseOrganizationCommentModal,
  };
};
